/* eslint-disable react/jsx-props-no-spreading */
import { ComponentProps } from 'react';
import type ReactMarkdown from 'react-markdown';

type ReactMarkdownProps = ComponentProps<typeof ReactMarkdown>;

const markdownComponents: NonNullable<ReactMarkdownProps['components']> = {
  p: (props) => <p className="mb-4 break-normal text-small last:mb-0" {...props} />,
  h2: ({ children, ...props }: { children: React.ReactNode }) => (
    <div className="mb-3.5 flex items-center pt-12 sm:pt-14">
      <div className="mr-3 inline-block h-6 w-2 bg-orange-700" />

      <h2
        id={children as string}
        className="inline-block align-middle text-large font-bold"
        {...props}
      >
        {children}
      </h2>
    </div>
  ),
  h3: ({ children, ...props }: { children: React.ReactNode }) => (
    <div className="mb-3.5 flex items-center pt-12">
      <div className="mr-3 inline-block h-6 w-2 bg-orange-700" />
      <h3
        id={children as string}
        className="inline-block align-middle text-large font-bold"
        {...props}
      >
        {children}
      </h3>
    </div>
  ),
  ol: ({ children }: { children: React.ReactNode }) => (
    <ol className="list-decimal space-y-2 pl-7 text-small">{children}</ol>
  ),
  ul: ({ children }: { children: React.ReactNode }) => (
    <ul className="list-disc space-y-2 pl-7 text-small">{children}</ul>
  ),
  table: (props) => <table className="mb-4 text-small last:mb-0" {...props} />,
  th: ({ children }: { children: React.ReactNode }) => <th className="p-3">{children}</th>,
  td: ({ children }: { children: React.ReactNode }) => <td className="p-1">{children}</td>,
  img: (props) => (
    <span className="block w-full sm:w-1/2" style={{ marginLeft: 'auto', marginRight: 'auto' }}>
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img {...props} />
    </span>
  ),
};

export default markdownComponents;
